// DO NOT EDIT -- generated from fs/api/fullstoryapis/settings/recording/v1alpha/recsettings.proto

import * as protobuf from '../../../../../../google/protobuf';

export namespace RecSettings {

  export const GetRecordingFeaturesEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetRecordingFeatures";
  export function GetRecordingFeatures(sender: (req: GetPlatformSettingsRequest, endpoint: string) => Promise<PublicRecordingFeatures>, req: GetPlatformSettingsRequest): { promise: () => Promise<PublicRecordingFeatures>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingFeaturesEndpoint),
      endpoint: GetRecordingFeaturesEndpoint
    };
  }

  export const GetPrivacySettingsEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetPrivacySettings";
  export function GetPrivacySettings(sender: (req: {}, endpoint: string) => Promise<PublicPrivacySettings>, req: {}): { promise: () => Promise<PublicPrivacySettings>, endpoint: string } {
    return {
      promise: () => sender(req, GetPrivacySettingsEndpoint),
      endpoint: GetPrivacySettingsEndpoint
    };
  }

  export const UpdateElementBlockRulesEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/UpdateElementBlockRules";
  /** @deprecated */
  export function UpdateElementBlockRules(sender: (req: UpdateElementBlockRulesRequest, endpoint: string) => Promise<UpdateElementBlockRulesResponse>, req: UpdateElementBlockRulesRequest): { promise: () => Promise<UpdateElementBlockRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateElementBlockRulesEndpoint),
      endpoint: UpdateElementBlockRulesEndpoint
    };
  }

  export const GetTargetingSettingsEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetTargetingSettings";
  export function GetTargetingSettings(sender: (req: {}, endpoint: string) => Promise<PublicTargetingRuleSet>, req: {}): { promise: () => Promise<PublicTargetingRuleSet>, endpoint: string } {
    return {
      promise: () => sender(req, GetTargetingSettingsEndpoint),
      endpoint: GetTargetingSettingsEndpoint
    };
  }

  export const GetGeoSettingsEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetGeoSettings";
  export function GetGeoSettings(sender: (req: {}, endpoint: string) => Promise<PublicGeoSettings>, req: {}): { promise: () => Promise<PublicGeoSettings>, endpoint: string } {
    return {
      promise: () => sender(req, GetGeoSettingsEndpoint),
      endpoint: GetGeoSettingsEndpoint
    };
  }

  export const GetDomainSettingsEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetDomainSettings";
  export function GetDomainSettings(sender: (req: GetPlatformSettingsRequest, endpoint: string) => Promise<PublicDomainSettings>, req: GetPlatformSettingsRequest): { promise: () => Promise<PublicDomainSettings>, endpoint: string } {
    return {
      promise: () => sender(req, GetDomainSettingsEndpoint),
      endpoint: GetDomainSettingsEndpoint
    };
  }

  export const GetRecordingBlockRulesEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetRecordingBlockRules";
  export function GetRecordingBlockRules(sender: (req: {}, endpoint: string) => Promise<PublicRecordingBlockRules>, req: {}): { promise: () => Promise<PublicRecordingBlockRules>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingBlockRulesEndpoint),
      endpoint: GetRecordingBlockRulesEndpoint
    };
  }

  export const GetRecordingFeaturesHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetRecordingFeaturesHistory";
  export function GetRecordingFeaturesHistory(sender: (req: GetPlatformHistoryRequest, endpoint: string) => Promise<RecordingFeaturesHistory>, req: GetPlatformHistoryRequest): { promise: () => Promise<RecordingFeaturesHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingFeaturesHistoryEndpoint),
      endpoint: GetRecordingFeaturesHistoryEndpoint
    };
  }

  export const GetPrivacySettingsHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetPrivacySettingsHistory";
  export function GetPrivacySettingsHistory(sender: (req: GetHistoryRequest, endpoint: string) => Promise<PrivacySettingsHistory>, req: GetHistoryRequest): { promise: () => Promise<PrivacySettingsHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetPrivacySettingsHistoryEndpoint),
      endpoint: GetPrivacySettingsHistoryEndpoint
    };
  }

  export const GetTargetingSettingsHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetTargetingSettingsHistory";
  export function GetTargetingSettingsHistory(sender: (req: GetHistoryRequest, endpoint: string) => Promise<TargetingSettingsHistory>, req: GetHistoryRequest): { promise: () => Promise<TargetingSettingsHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetTargetingSettingsHistoryEndpoint),
      endpoint: GetTargetingSettingsHistoryEndpoint
    };
  }

  export const GetGeoSettingsHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetGeoSettingsHistory";
  export function GetGeoSettingsHistory(sender: (req: GetHistoryRequest, endpoint: string) => Promise<GeoSettingsHistory>, req: GetHistoryRequest): { promise: () => Promise<GeoSettingsHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetGeoSettingsHistoryEndpoint),
      endpoint: GetGeoSettingsHistoryEndpoint
    };
  }

  export const GetDomainSettingsHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetDomainSettingsHistory";
  export function GetDomainSettingsHistory(sender: (req: GetPlatformHistoryRequest, endpoint: string) => Promise<DomainSettingsHistory>, req: GetPlatformHistoryRequest): { promise: () => Promise<DomainSettingsHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetDomainSettingsHistoryEndpoint),
      endpoint: GetDomainSettingsHistoryEndpoint
    };
  }

  export const GetRecordingBlockRulesHistoryEndpoint = "/grpc/fullstory.settings.recording.v1.RecSettings/GetRecordingBlockRulesHistory";
  export function GetRecordingBlockRulesHistory(sender: (req: GetHistoryRequest, endpoint: string) => Promise<RecBlockRulesHistory>, req: GetHistoryRequest): { promise: () => Promise<RecBlockRulesHistory>, endpoint: string } {
    return {
      promise: () => sender(req, GetRecordingBlockRulesHistoryEndpoint),
      endpoint: GetRecordingBlockRulesHistoryEndpoint
    };
  }
}

export interface PublicRecordingFeatures {
  enabled: boolean;
  consoleWatcher: boolean;
  ajaxWatcher: boolean;
  resourceUploading: boolean;
  recordingShutoff: boolean;
  metadata: PublicAuditMetadata | null;
  clientSideRageClick: boolean;
}

/** CanvasWatcherMode tells whether canvas capture is enabled for an org. */
export enum CanvasWatcherMode {
  DISABLED = 0,
  CAPTURE_CANVAS_OPS = 1,
  SNAPSHOT_CANVAS = 2
}

export enum BlockType {
  UNSET = 0,
  BLOCK_EXCLUDE = 1,
  BLOCK_MASK = 2,
  BLOCK_UNMASK = 3
}

/**
 * RecordingActiveFor tells whether recording is enabled for an org.
 * Note the differences with the `RuleScope` enum: An UNSET zero state, and no LIVE_SESSIONS_ONLY.
 */
export enum RecordingActiveFor {
  REC_UNSET = 0,
  REC_ALL_SESSIONS = 1,
  REC_NO_SESSIONS = 2,
  REC_PREVIEW_SESSIONS_ONLY = 3
}

/**
 * RuleScope is used to limit the scope exclusion rules
 * so a customer can dogfood a rule in "audited" sessions they record
 * themselves before turning the rule on for all of their users.
 */
export enum RuleScope {
  /** Apply always (default). */
  ALL_SESSIONS = 0,
  /** Never apply. */
  NO_SESSIONS = 1,
  /** Apply only for "previewed" sessions e.g. to test the addition of a BLOCK_UNMASK rule. */
  PREVIEW_SESSIONS_ONLY = 2,
  /** Apply only for non-preview sessions e.g. to test the removal of an BLOCK_EXCLUDE rule. */
  LIVE_SESSIONS_ONLY = 3
}

export enum RecordAjaxBody {
  ELIDE = 0,
  RECORD = 1,
  WHITELIST = 2
}

export enum Editable {
  EDITABLE_ANY = 0,
  EDITABLE_DESCRIPTION_ONLY = 1,
  EDITABLE_DESCRIPTION_SCOPE_AND_EXCEPTIONS = 2
}

export interface PublicElementBlockRules {
  selector: string;
  consent: boolean;
  notes: string;
  type: BlockType;
  scope: RuleScope;
  lastUpdated: protobuf.timestamp | null;
  label: string;
  /** @deprecated */
  targetingConditions: TargetingConditionSet | null;
  editable: Editable;
  exceptionSelectors: string[];
  /** Membership in a privacy rule group. 0 means no group. */
  groupId: number;
}

export interface ElementPrivacyRuleGroup {
  groupId: number;
  /** Used by the UI to add special copy or rendering. */
  templateId: BuiltInRuleGroup;
  note: string;
  overrides: ElementPrivacyRuleOverride | null;
}

/**
 * ElementPrivacyRuleOverride is used to define properties of Rule Groups that override properties of member rules.
 * This message is similar to ElementBlockRulesUpdate, but with different properties.
 */
export interface ElementPrivacyRuleOverride {
  /** This property is used to represent enabling/disabling whole groups of rules. */
  scope: RuleScope;
  editable: Editable;
}

/** We need to distinguish the built in Form Privacy rule group so the UI can render it specially. */
export enum BuiltInRuleGroup {
  NONE = 0,
  FORM_PRIVACY = 1,
  MOBILE_UNMASK_DEFAULTS = 2
}

export interface AjaxWatchRule {
  urlRegex: string;
  recordReq: RecordAjaxBody;
  recordRsp: RecordAjaxBody;
  whitelistReq: string;
  whitelistRsp: string;
}

export interface PublicPrivacySettings {
  /**
   * This field contains the raw element blocks set by the customer as part of
   * their recording configuration. Don't use it directly for recording;
   * instead, call EvalElementBlocks() to get the final set of element blocks
   * that the recording script/plugins should see.
   */
  elementBlocks: PublicElementBlockRules[];
  ajaxWatches: AjaxWatchRule[];
  discardIpAddresses: boolean;
  metadata: PublicAuditMetadata | null;
  defaultPrivacyMode: string;
  /** Element Privacy rule groups for this org. */
  elementRuleGroups: { [key: string]: ElementPrivacyRuleGroup };
}

/** Patterns that we can use in conditions or blocklists. */
export interface Pattern {
  /** Raw rule expression value */
  expression: string;
}

/** A set of optional lists of Patterns of the various kinds we support. */
export interface PatternSet {
  hash: Pattern[];
  host: Pattern[];
  path: Pattern[];
  queryParam: Pattern[];
  query: Pattern[];
}

/** A single URL privacy rule. */
export interface UrlPrivacyRule {
  /** The condition for this rule; if not present, the rule is unconditional. */
  if: PatternSet[];
  /**
   * Exclusions to apply if the condition is true. This too is just a
   * PatternSet; in this context, it's interpreted similarly to the blocklists
   * we have today.
   */
  exclude: PatternSet | null;
  /** User submitted note about the rule to help provide context to why it exists. */
  note: Note | null;
  /** unique id for lookups and updates for a specific privacy rule. */
  guid: string;
  builtInRuleGroup: BuiltInUrlPrivacyRuleGroup;
  /** Human readable name for the rule to be identified as */
  name: string;
}

/** Note field for URL privacy rules. */
export interface Note {
  email: string;
  note: string;
  when: protobuf.timestamp | null;
}

/**
 * Enum to represent different URL privacy rule types.
 * Right now this is just used to distinguish the default
 * rule set that is created when Privacy Settings are set up
 * for a customer
 */
export enum BuiltInUrlPrivacyRuleGroup {
  NO_GROUP = 0,
  BUILT_IN = 1
}

/** ------ Element Block Rules ------ */
export interface ElementBlockRuleException {
  /** CSS selectors identifying elements that this block rule should NOT apply to. */
  selector: string;
}

export interface AddElementBlockRules {
  /**
   * A CSS selector identifying the elements that this block rule should apply to.
   * Required.
   */
  selector: string;
  /**
   * Membership in a privacy rule group.
   * Defaults to 0, means no group.
   */
  groupId: number;
  /**
   * If true, indicates that it is safe to record these elements in sessions with user consent.
   * Optional. Defaults to false.
   */
  consentControlled: boolean;
  /**
   * Administrator notes about this rule.
   * Optional.
   */
  notes: string;
  /**
   * What type of block rule this is. See Fullstory privacy documentation for details.
   * Optional. Defaults to BLOCK_EXCLUDE.
   */
  type: BlockType;
  /**
   * The scope of the rule, which determines which sessions are affected.
   * Optional. Defaults to ALL_SESSIONS.
   */
  scope: RuleScope;
  /** CSS selectors identifying elements that this block rule should NOT apply to. */
  ruleExceptions: ElementBlockRuleException[];
}

export interface UpdateElementBlockRules {
  /**
   * Subset of properties from ElementBlockRules used for uniquely identifying the ElementBlockRules.
   * Required.
   */
  key: ElementBlockRuleKey | null;
  /**
   * The desired update values for the ElementBlockRules
   * Required.
   */
  update: ElementBlockRulesUpdate | null;
}

/** The desired update values for the UpdateElementBlockRules all fields are optional. */
export interface ElementBlockRulesUpdate {
  /**
   * A CSS selector identifying the elements that this block rule should apply to.
   * Optional. No-op when not provided, or if an empty string is provided.
   */
  selector: string;
  /**
   * If true, indicates that it is safe to record these elements in sessions with user consent.
   * Optional. No-op when not provided.
   */
  consentControlled: boolean | null;
  /**
   * Administrator notes about this rule.
   * Optional. No-op when not provided. Providing an empty string will remove any existing notes.
   */
  notes: string | null;
  /**
   * What type of block rule this is. See Fullstory privacy documentation for details.
   * Optional. No-op when not provided.
   */
  type: BlockType;
  /**
   * The scope of the rule, which determines which sessions are affected.
   * Optional. No-op when not provided.
   */
  scope: ElementBlockRulesUpdate.SessionScope;
  /**
   * A list of exceptions identifying elements by CSS selectors that this block rule should NOT apply to.
   * The entire list will be replaced, any existing exceptions will be cleared if not provided,
   * or if an empty array [] is provided.
   */
  ruleExceptions: protobuf.ListValue | null;
  /**
   * Membership in a privacy rule group.
   * Optional. No-op when not provided
   */
  groupId: number | null;
}

/** The desired update values for the UpdateElementBlockRules all fields are optional. */
export namespace ElementBlockRulesUpdate {
  /**
   * SessionScope includes all the possible RuleScope enums, but adds an UNSET default.
   * Since RuleScope doesn't have a UNSET, we can't safely perform no-op.
   * Using a wrapper like RuleScopeUpdate makes the API inconsistent for callers,
   * as it requires callers to provide a "value" field, which looks like below (json):
   * { "rule_scope": { "value": "ALL_SESSIONS" } }.
   * So, instead, the new SessionScope enum defaults to UNSET that allows a easy notion of "no-op"
   * NB: It's also important to know that now the actual int value is different from that in RuleScope,
   * making it necessary to use the string representations, not integers!
   */
  export enum SessionScope {
    UNSET = 0,
    ALL_SESSIONS = 1,
    NO_SESSIONS = 2,
    PREVIEW_SESSIONS_ONLY = 3,
    LIVE_SESSIONS_ONLY = 4
  }
}

export interface UpdateElementBlockRulesRequest {
  addElementBlocks: AddElementBlockRules[];
  updateElementBlocks: UpdateElementBlockRules[];
  removeElementBlocks: ElementBlockRuleKey[];
}

export interface UpdateElementBlockRulesResponse {
  elementBlocks: PublicElementBlockRules[];
}

/**
 * ElementBlockRuleKey represents the subset of ElementBlockRules
 * properties which, in conjunction, identify an element privacy rule.
 * Future properties added to this message should have wrapper types
 * (see ElementBlockRulesUpdate) iff they're optional.
 */
export interface ElementBlockRuleKey {
  /** A CSS selector identifying the elements that this block rule should apply to. */
  selector: string;
  /**
   * Membership in a privacy rule group.
   * Defaults to 0, means no group.
   */
  groupId: number;
}

export interface PublicTargetingRuleSet {
  sessionTargetingRules: TargetingRule[];
  metadata: PublicAuditMetadata | null;
}

/**
 * Targeting rules for privacy settings and session recording
 * Attributes of the session compared against in a TargetingRuleCondition
 */
export enum TargetingRuleAttribute {
  TGT_RULE_ATTR_INVALID = 0,
  /**
   * common
   * identified user
   */
  UID = 1,
  IP = 2,
  LOCATION = 3,
  /** a value of schema.PageTypeEnum */
  PLATFORM = 13,
  /** web related */
  DOMAIN = 4,
  USER_AGENT = 5,
  /**
   * native mobile related
   * application version string (can be normalized to a numeric value for comparison operators, if in dotted quad form)
   */
  APP_VERSION = 6,
  /** application build variant */
  BUILD_TYPE = 7,
  /** application fs instrumentation version */
  FS_VERSION = 8,
  /** application fs build id */
  FS_BUILD_ID = 9,
  /** operating system version */
  OS_VERSION = 10,
  /** device model */
  MODEL = 11,
  /** device manufacturer */
  MANUFACTURER = 12
}

/** Comparison operators that we use to compare a targeting attribute’s incoming value against a declared value in a TargetingRuleCondition */
export enum TargetingRuleOperator {
  TGT_RULE_OP_INVALID = 0,
  EQ = 1,
  NEQ = 2,
  LT = 3,
  LTE = 4,
  GT = 5,
  GTE = 6,
  RANGE = 7,
  CONTAINS = 8
}

/** Represents a dotted quad version number */
export interface TargetingRuleVersionValue {
  major: protobuf.uint64;
  minor: protobuf.uint64;
  build: protobuf.uint64;
  revision: protobuf.uint64;
}

export interface TargetingRuleValue {
  strVal?: string;
  intVal?: protobuf.int64;
  versionVal?: TargetingRuleVersionValue | null;
}

export namespace TargetingRuleValue {
  export enum val {
    strVal = 1,
    intVal = 2,
    versionVal = 3
  }

  export function val_oneof(m: TargetingRuleValue): { opt: val.intVal, val: protobuf.int64 } | { opt: val.strVal, val: string } | { opt: val.versionVal, val: TargetingRuleVersionValue } | null {
    if (m.strVal != null) { return { opt: val.strVal, val: m.strVal } }
    if (m.intVal != null) { return { opt: val.intVal, val: m.intVal } }
    if (m.versionVal != null) { return { opt: val.versionVal, val: m.versionVal } }
    return null;
  }
}

export interface TargetingRuleCondition {
  attr: TargetingRuleAttribute;
  op: TargetingRuleOperator;
  values: TargetingRuleValue[];
  /** conjunction type to use for the previous condition if multiple */
  joinPrevious: TargetingRuleConjunction;
}

/** Joins multiple TargetingRuleConditions and/or TargetingRules */
export enum TargetingRuleConjunction {
  TGT_RULE_CNJ_INVALID = 0,
  AND = 1,
  OR = 2
}

/** a reference to a rule by id and a join operator for expressing composite rules */
export interface TargetingRuleChildRef {
  id: string;
  joinPrevious: TargetingRuleConjunction;
}

/**
 * TargetingRule is a collection of TargetingRuleConditions and (optionally) composed of other defined TargetingRules.
 * TargetingRules be associated with a Selector for further specificity in privacy rules, or used to conditionally block sessions.
 */
export interface TargetingRule {
  /** a named identifier for this rule, which can be referenced to build a composite rule by a UI */
  id: string;
  /** additional information provided by the author */
  notes: string;
  scope: RuleScope;
  /** the set of conditions for this rule */
  conditions: TargetingRuleCondition[];
  /** for expressing composite rules */
  children: TargetingRuleChildRef[];
}

export interface TargetingConditionSet {
  privacyTargetingConditions: TargetingRuleCondition[];
}

export enum GeoRecordMode {
  GEO_ALL = 0,
  GEO_ALLOW_LIST = 1,
  GEO_BLOCK_LIST = 2
}

export interface PublicGeoSettings {
  recordGeoMode: GeoRecordMode;
  recordGeoZones: string[];
  metadata: PublicAuditMetadata | null;
}

export interface KnownDomain {
  disabled: boolean;
  domain: string;
}

export interface PublicDomainSettings {
  onlyRecordKnownDomains: boolean;
  domains: KnownDomain[];
  metadata: PublicAuditMetadata | null;
}

export interface PublicRecordingBlockRules {
  blockedIps: string[];
  blockedUas: string[];
  blockedAppIds: string[];
  metadata: PublicAuditMetadata | null;
}

export interface GetPlatformSettingsRequest {
  /** Determines which platform to show settings from - `web` or `mobile`. Defaults to `web`. */
  platform: string;
}

export interface GetHistoryRequest {
  /** The token to start the page at. The default is the most recent version of settings. */
  paginationToken: string;
  /** The max number of returned versions. The default is 20 and the max is 100. */
  limit: number;
}

export interface GetPlatformHistoryRequest {
  /** The token to start the page at. The default is the most recent version of settings. */
  paginationToken: string;
  /** The max number of returned versions. The default is 20 and the max is 100. */
  limit: number;
  /** Determines which platform to show settings from - `web` or `mobile`. Defaults to `web`. */
  platform: string;
}

export interface PrivacySettingsHistory {
  versions: PublicPrivacySettings[];
  nextPaginationToken: string;
}

export interface DomainSettingsHistory {
  versions: PublicDomainSettings[];
  nextPaginationToken: string;
}

export interface RecordingFeaturesHistory {
  versions: PublicRecordingFeatures[];
  nextPaginationToken: string;
}

export interface RecBlockRulesHistory {
  versions: PublicRecordingBlockRules[];
  nextPaginationToken: string;
}

export interface GeoSettingsHistory {
  versions: PublicGeoSettings[];
  nextPaginationToken: string;
}

export interface TargetingSettingsHistory {
  versions: PublicTargetingRuleSet[];
  nextPaginationToken: string;
}

/** This is a public-facing semi-duplicate of protoauditstore.AuditMetadata */
export interface PublicAuditMetadata {
  /** When this entity was last updated. */
  lastUpdated: protobuf.timestamp | null;
  /** Who made the last update to this entity. */
  lastUpdatedBy: string;
  /** When this entity was first created. */
  created: protobuf.timestamp | null;
  /** Who first created this entity. */
  createdBy: string;
}
